import { UseHotelFiltersFormProperties } from "@website/accommodation-ui/hotel-filter/hotel-filter.types";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";

export const useHotelFiltersForm = (
  properties: UseHotelFiltersFormProperties
) => {
  const router = useRouter();
  const { hotelListResultsCount, loading } = properties;
  return {
    title: "فیلترها",
    resetButtonProps: {
      size: "small" as const,
      color: "secondary" as const,
      variant: "text" as const
    },
    footerProps: {
      loading: hotelListResultsCount === "loading" || loading,
      filtersActionTitle: `مشاهده ${numberConvert(hotelListResultsCount ?? 0, {
        locale: router.locale
      })} نتیجه`
    }
  };
};
